import ace from 'ace';
import python from 'mode-python';





import View from '../view';





export default View.extend( {

    serialize() {
        const { code } = this.options;
        return { code };
    },

    afterRender(context, firstTime) {
        const editor = ace.edit( 'editor' );
        editor.session.setMode( 'ace/mode/python' );
        editor.session.on( 'change', 
            () => this.trigger( 'edit', editor.getValue() ) );
    },

} );



// WEBPACK FOOTER //
// ./src/js/view/ext/ace.js